import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { OtherExpensesModel } from 'api-hooks/other-expense';
import { OtherIncomeModel } from 'api-hooks/other-income';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { getTourTippingsInput } from './model';

export function useGetTourOtherExpenses(
  input?: getTourTippingsInput,
  options?: UseQueryOptions<ExtendedApiResult<OtherExpensesModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<OtherExpensesModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-other-expenses-tour', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}/get-other-expenses`,
          params: input?.params,
        }),
      options,
    ),
    OtherExpensesModel,
  );
}

export function useGetTourOtherIncomes(
  input?: getTourTippingsInput,
  options?: UseQueryOptions<ExtendedApiResult<OtherIncomeModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<OtherIncomeModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-other-incomes-tour', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}/get-other-incomes`,
          params: input?.params,
        }),
      options,
    ),
    OtherIncomeModel,
  );
}

export function getTipsKey(input?: getTourTippingsInput) {
  return ['getTourTippings', input?.params];
}
